<template>
    <v-container fluid class="pr-0 pl-0">
        <client-only>
            <v-row column justify-center align-center>
                <v-col v-if="isLoggedIn" cols="12">
                    <TranslatableBlockComponent :tstring="{string: 'loggedInMessage'}" />
                </v-col>
                <v-col v-else cols="12">
                    <v-card class="mx-auto mt-5" width="500">
                        <v-progress-linear
                            v-if="loader"
                            indeterminate
                            color="primary"
                        ></v-progress-linear>
                        <v-card-title v-if="heading">
                            <h1 class="display-1 mx-auto">
                                <TranslatableStringComponent :tstring="{string: 'login'}" />
                            </h1>
                        </v-card-title>
                        <v-card-text class="pa-0">
                            <ValidationObserver
                                ref="observer"
                                v-slot="{ handleSubmit }"
                            >
                                <v-form
                                    id="accountLogin"
                                    ref="accountLogin"
                                    data-netlify="true"
                                    data-netlify-honeypot="bot-field"
                                    name="accountLogin"
                                    action="/my-account/dashboard/"
                                    method="POST"
                                    @submit.prevent="handleSubmit(handleLogin)"
                                >
                                    <input
                                        id="form-name"
                                        v-model="loginCreds.formName"
                                        type="hidden"
                                        name="form-name"
                                        value="accountLogin"
                                    />
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12">
                                                <ValidationProvider
                                                    name="accountEmail"
                                                    rules="required|email|emoji"
                                                    class="validationWrapper"
                                                >
                                                    <div
                                                        slot-scope="{ errors }"
                                                    >
                                                        <span
                                                            class="validationMessage"
                                                            >{{
                                                                errors[0]
                                                            }}</span
                                                        >
                                                        <v-text-field
                                                            id="accountEmail"
                                                            v-model="
                                                                loginCreds.email
                                                            "
                                                            name="accountEmail"
                                                            :label="
                                                                localize(
                                                                    'email'
                                                                )
                                                            "
                                                            :hint="hints.email"
                                                        >
                                                            <v-icon
                                                                slot="prepend"
                                                                dense
                                                            >
                                                                fa-envelope
                                                            </v-icon>
                                                        </v-text-field>
                                                    </div>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col cols="12">
                                                <ValidationProvider
                                                    name="accountPassword"
                                                    rules="required"
                                                    class="validationWrapper"
                                                >
                                                    <div
                                                        slot-scope="{ errors }"
                                                    >
                                                        <span
                                                            class="validationMessage"
                                                            >{{
                                                                errors[0]
                                                            }}</span
                                                        >
                                                        <!-- id="accountPassword" -->
                                                        <!-- name="accountPassword" -->
                                                        <v-text-field
                                                            v-model="
                                                                loginCreds.password
                                                            "
                                                            :label="
                                                                localize(
                                                                    'password'
                                                                )
                                                            "
                                                            :type="
                                                                showPassword
                                                                    ? 'text'
                                                                    : 'password'
                                                            "
                                                            :hint="
                                                                hints.password
                                                            "
                                                        >
                                                            <v-icon
                                                                slot="prepend"
                                                                dense
                                                            >
                                                                fa-lock
                                                            </v-icon>

                                                            <template
                                                                v-slot:append
                                                            >
                                                                <span
                                                                    tabindex="-1"
                                                                    style="
                                                                        cursor: pointer;
                                                                    "
                                                                    @click="
                                                                        showPassword = !showPassword
                                                                    "
                                                                >
                                                                    <v-icon
                                                                        v-if="
                                                                            showPassword
                                                                        "
                                                                        dense
                                                                        >fa-eye</v-icon
                                                                    >
                                                                    <v-icon
                                                                        v-else
                                                                        dense
                                                                        >fa-eye-slash</v-icon
                                                                    >
                                                                </span>
                                                            </template>
                                                        </v-text-field>
                                                    </div>
                                                </ValidationProvider>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                :class="{
                                                    'py-0':
                                                        $vuetify.breakpoint
                                                            .smAndDown,
                                                }"
                                            >
                                                <recaptcha
                                                    @success="onSuccess"
                                                    @error="onError"
                                                    @expired="onExpired"
                                                />
                                                <div
                                                    v-if="captchaError"
                                                    class="captcha-error"
                                                >
                                                    <TranslatableStringComponent :tstring="{string: 'captchaRequired'}" />
                                                </div>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                                <v-btn
                                                    type="submit"
                                                    color="primary"
                                                    :disabled="loader"
                                                    :loading="loader"
                                                    >
                                                        <TranslatableStringComponent :tstring="{string: 'login'}" />
                                                    </v-btn
                                                >
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                sm="8"
                                                class="text-sm-right"
                                            >
                                                <p>
                                                    <TranslatableStringComponent :tstring="{string: 'needToRegister'}" />
                                                    <nuxt-link
                                                        :to="
                                                            getStaticLocalePath(
                                                                {
                                                                    type:
                                                                        'page',
                                                                    slugName:
                                                                        'register',
                                                                }
                                                            )
                                                        "
                                                    >
                                                        <TranslatableStringComponent :tstring="{string: 'registerHere'}" />
                                                    </nuxt-link>
                                                </p>
                                                <span>
                                                    <nuxt-link
                                                        :to="
                                                            getStaticLocalePath(
                                                                {
                                                                    type:
                                                                        'page',
                                                                    slugName:
                                                                        'verify-email',
                                                                }
                                                            )
                                                        "
                                                    >
                                                        <TranslatableStringComponent :tstring="{string: 'forgotMyPassword'}" />
                                                    </nuxt-link>
                                                </span>
                                            </v-col>
                                            <v-col cols="12" class="pt-0"
                                                ><small
                                                    style="
                                                        line-height: 1.5;
                                                        font-style: italic;
                                                    "
                                                    >
                                                    <TranslatableStringComponent :tstring="{string: 'noGuestCheckout'}" />
                                                    <nuxt-link
                                                        :to="
                                                            getStaticLocalePath(
                                                                {
                                                                    type:
                                                                        'page',
                                                                    slugName:
                                                                        'contact',
                                                                }
                                                            )
                                                        "
                                                        ><TranslatableStringComponent :tstring="{string: 'contactUs'}" /></nuxt-link
                                                    >.</small
                                                ></v-col
                                            >
                                        </v-row>
                                    </v-container>
                                </v-form>
                            </ValidationObserver>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-dialog v-model="dialog" max-width="500">
                <v-card>
                    <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                        >
                        <TranslatableStringComponent :tstring="{string: 'welcomeV1user'}" />
                    </v-card-title
                    >
                    <v-card-text>
                        <p v-show="firstName">
                            {{ 'Hi, ' }}
                            <strong>{{ firstName }}</strong>
                            <strong v-show="lastName">{{ lastName }}</strong>
                        </p>
                        <v-spacer></v-spacer>
                        <TranslatableStringComponent :tstring="{string: 'welcomeV1blurb'}" />
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            :to="
                                getStaticLocalePath({
                                    type: 'page',
                                    slugName: 'register',
                                })
                            "
                        >
                            <TranslatableStringComponent :tstring="{string: 'confirmAccount'}" />
                        </v-btn>
                        <v-btn
                            color="primary"
                            text
                            :to="
                                getStaticLocalePath({
                                    type: 'page',
                                    slugName: 'register',
                                })
                            "
                        >
                            <TranslatableStringComponent :tstring="{string: 'newAccount'}" />
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </client-only>
    </v-container>
</template>
<script>
import { mapActions } from 'vuex'

import { gtmEvent } from '~/plugins/global'
import formUtilities from '~/mixins/formUtilities'
import handleSnackbar from '~/mixins/handleSnackbar'
import handleAuth from '~/mixins/handleAuth'
import handleRecaptcha from '~/mixins/handleRecaptcha'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import TranslatableBlockComponent from '~/components/TranslatableBlockComponent.vue'

export default {
    name: 'FormLogin',
    mixins: [formUtilities, handleSnackbar, handleAuth, handleRecaptcha],
    components: {
        TranslatableStringComponent,
        TranslatableBlockComponent,
    },
    props: {
        heading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showPassword: false,
            displayError: '',
            loginCreds: {
                email: null,
                password: null,
                formName: 'accountLogin',
            },
            dialog: false,
            firstName: '',
            lastName: '',
        }
    },
    methods: {
        ...mapActions('auth', [
            'attemptLogin',
            'getExistingUser',
            'checkNetlifyStatus',
        ]),
        handleLogin() {
            if (!this.token) {
                this.captchaError = true
                return
            }
            const token = this.signupToken
            const locale = this.$i18n.locale
            // console.log('token', token)
            this.loader = true

            this.$axios
                .post('reCaptcha-server-side-validation', {
                    token: this.token,
                })
                .then((res) => {
                    // console.log('RECAPTCHA RESPONSE:', res)
                    if (res.data && res.data.success === false) throw res.data

                    this.getExistingUser(this.loginCreds.email)
                        .then((resp) => {
                            const isExistingV1UnregisteredUser =
                                resp.length > 0 &&
                                resp[0].email.toLowerCase() ===
                                    this.loginCreds.email.toLowerCase() &&
                                !resp[0].isRegistered

                            this.attemptLogin({
                                token,
                                ...this.loginCreds,
                            })
                                .then(() => {
                                    this.hitSnackbar(
                                        { string :'successfulLoginMessage'},
                                        ''
                                    )
                                    if (
                                        this.$store.state.savedCarts
                                            .showMaxLimitMessage
                                    ) {
                                        setTimeout(() => {
                                            this.hitSnackbar(
                                                { string:
                                                    'savedCartMaxLimitMessage'
                                                },
                                                null,
                                                'warning',
                                                10000
                                            )
                                        }, 9000)
                                    }
                                    this.$store.commit(
                                        'savedCarts/showMaxLimitMessage',
                                        false
                                    )
                                    gtmEvent({
                                        gtm: this.$gtm,
                                        event: 'accountLogin',
                                        eventType: 'form',
                                        atts: {},
                                    })
                                    this.loader = false
                                    const previousRoute = localStorage.getItem(
                                        'c3prev'
                                    )
                                    if (
                                        previousRoute?.includes('register') ||
                                        previousRoute?.includes(
                                            'reset-password'
                                        ) ||
                                        previousRoute?.includes('login') ||
                                        previousRoute === '/'
                                    ) {
                                        this.routerPush({
                                            type: 'account',
                                            slugName: 'dashboard',
                                        })
                                    } else if (
                                        previousRoute?.includes('cart')
                                    ) {
                                        this.routerPush({
                                            type: 'page',
                                            slugName: 'cart',
                                        })
                                    } else {
                                        this.$router.back()
                                    }
                                })
                                .catch((err) => {
                                    console.log(err)
                                    this.loader = false
                                    this.$recaptcha.reset()
                                    const errorMessage = err.error_description
                                    if (
                                        errorMessage?.includes('No user') &&
                                        isExistingV1UnregisteredUser
                                    ) {
                                        this.dialog = true
                                        this.firstName =
                                            resp[0].firstName
                                                .charAt(0)
                                                .toUpperCase() +
                                            resp[0].firstName.slice(1)
                                        this.lastName =
                                            resp[0].lastName
                                                .charAt(0)
                                                .toUpperCase() +
                                            resp[0].lastName.slice(1)
                                    } else {
                                        this.hitSnackbar({string: 'noUserFoundWithThatEmailOrPasswordInvalid'}, {})
                                        console.log(
                                            'Hmm... something went wrong on FormLogin.vue',
                                            errorMessage
                                        )
                                    }
                                })
                        })
                        .catch((err) => {
                            const errorMessage = err
                            this.handleErrors(errorMessage)
                            console.log(
                                'Hmm... something went wrong on FormLogin.vue',
                                errorMessage
                            )
                        })
                })
                .catch((err) => {
                    const errorMessage = 'recaptchaFailedMessage'
                    console.log(errorMessage, err)
                    this.handleErrors(errorMessage)
                })
        },
        handleErrors(errorMessage) {
            this.$recaptcha.reset()
            this.loader = false
            this.hitSnackbar( { string: errorMessage }, {})
        },
    },
}
</script>
